<template>
    <div v-if="visible" class="container">
        <div class="row no-gutters">
            <div class="col-md-12 section-title">
                <h2>Edycja profilu</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 edit-profile">
                <form v-on:submit.prevent="save()" autocomplete="off">
                    <fieldset :disabled="!this.editable">
                        <!-- TODO fix TextInput and replace this code -->
                        <div>
                            <label class="my-2" :for="'form-rfid'">Kod RFID:</label>
                            <input class="form-control" type="text" :name="'rfid'" :id="'form-rfid'" v-model="rfid">
                        </div>
                        <div>
                            <label class="my-2" :for="'form-color'">Kolor:</label>
                            <input class="form-control" type="color" :name="'color'" :id="'form-color'" v-model="color">
                        </div>
                        <div>
                            <label class="my-2 mr-2" :for="'form-reversed'">Odwróć kolor tekstu:</label>
                            <input type="checkbox" :name="'reversed'" :id="'form-reversed'" v-model="reversed">
                        </div>
                    </fieldset>
                    <div class="edit-profile__action-btns float-right">
                        <button class="btn btn-grey m-r-10" type="button"
                                @click="loadProfile()" v-if="this.editable">Anuluj
                        </button>
                        <button class="btn btn-orange" type="submit" v-if="this.editable">Zapisz</button>
                    </div>
                </form>
              <button class="btn btn-blue edit-button" type="button" v-if="!this.editable" @click="edit()">Edytuj</button>
            </div>
        </div>
        <div class="show-label"><span>Podgląd etykiety:</span>
            <span :style="{'border-color': this.color, 'color': textColor}">{{ username }}</span>
        </div>
    </div>
</template>

<script>
    import {backend} from '../../backend';
    import TextInput from '../TextInput.vue';

    export default {
        name: 'EditProfile',
        components: {
            TextInput
        },
        data() {
            return {
                rfid: '',
                color: '#ffffff',
                reversed: false,
                editable: false,
                visible: false,
                privateKey: '',
                disabled: false,
            }
        },
        created: function () {
            this.loadProfile();
        },
        computed: {
            username() {
                return this.$store.getters['auth/username'];
            },
            textColor() {
                return this.reversed ? '#ffffff' : "#000000";
            },
        },
        methods: {
            loadProfile: function () {
                backend.getProfile()
                    .then((response) => {
                        this.rfid = response.data.key_rfid;
                        this.color = response.data.color;
                        this.reversed = response.data.text_color_reversed;
                        this.editable = false;
                        this.visible = true;
                    });
            },
            save: function () {
                let data = {
                    'key_rfid': this.rfid,
                    'color': this.color,
                    'text_color_reversed': this.reversed,
                };
                backend.saveProfile(data)
                    .then(() => {
                        this.editable = false;
                    })
                    .catch((err) => {
                        this.$vs.notify({text: err.response.data.detail, color: 'danger'});
                    });
            },
            edit: function () {
                this.editable = true;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .edit-button{
      float:right;
    }
    .preview {
        text-align: center;
        vertical-align: middle;
        height: 40px;
        width: 200px;
        margin: 10px;
    }

    .section-title {
        border-bottom: 1px solid #ddd;
        margin-bottom: 10px;
        padding-bottom: 5px;

        h2 {
            font-size: 1.7rem;
            color: #235ba6;
            margin: 0;
            font-weight: 500;
        }
    }

    .edit-profile {
        margin-top: 1rem;

        fieldset {
            float: left;
        }

        fieldset > div {
            display: inline-block;
            vertical-align: middle;
            margin-right: 30px;
        }

        .form-control {
            display: inline;
            width: 120px;
            margin-left: 10px;
        }

        &:__action-btns {
            overflow: hidden;
        }
    }

    .show-label {
        margin-top: 1.4rem;
        border-top: 1px solid #e7e7e7;
        padding-top: 1.4rem;

        > span {
            display: inline-block;
        }

        > span:last-child {
            padding: 3px 50px;
            border-radius: 3px;
            margin-left: .5rem;
            border: 1px solid;
            border-top: 3px solid;
        }
    }

    label {
        color: #808080;
    }
</style>


// WEBPACK FOOTER //
// EditProfile.vue?52458259